<template>
    <div class="right-top-box">
        <div class="left-box">
            <el-breadcrumb separator-class="el-icon-arrow-right" v-if="this.breadData">
                <el-breadcrumb-item v-for="(v, k) in breadData" :key="k">{{v}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="right-box">
            <el-button type="primary" class="store-name" @click="showSwitchStore">{{userInfo.store_name}}</el-button>
            <!--<router-link to="/boss/index" class="backup" v-if="is_show_back"><el-button size="small">返回</el-button></router-link>-->
            <!--<img class="user-avatar" v-if="userInfo.avatar != ''" :src="userInfo.avatar" />-->
            <!--<img class="user-avatar" v-else src="../images/avatar_default.png" />-->
            <div class="user-mobile">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                    {{userInfo.mobile}}<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="user-drop-box">
                        <el-dropdown-item @click.native="editShow=true">
                            <div class="password"><i class="el-icon-lock"></i>修改密码</div>
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="loginOut">
                            <div class="login-out">退出</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <!--修改密码框-->
        <pop-form v-if="editShow" width="500px">
            <template v-slot:title>修改密码</template>
            <div class="editPasswordForm">
            <el-form ref="editData" :model="editData" label-width="150px">
                <el-form-item label="旧密码" prop="old_password" :rules='[
                        {required: true, message: "请填写旧密码"},
                    ]'>
                    <el-input v-model="editData.old_password" placeholder="请输入旧密码" show-password></el-input>
                </el-form-item>

                <el-form-item label="新密码" prop="new_password" :rules='[
                        {required: true, message: "请填写新密码"},
                    ]'>
                    <el-input v-model="editData.new_password" placeholder="请输入你要修改的新密码" show-password></el-input>
                </el-form-item>

                <el-form-item label="确认密码" prop="new_password2" :rules='[
                        {required: true, message: "请再次输入新密码"},
                    ]'>
                    <el-input v-model="editData.new_password2" placeholder="请再次输入修改的新密码" show-password></el-input>
                </el-form-item>
            </el-form>
            </div>
            <template v-slot:foot>
                <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button size="medium" @click="editShow = false">&nbsp;&nbsp;关闭&nbsp;&nbsp;</el-button>
            </template>
        </pop-form>

        <!--切换门店-->
        <ChainSwitchStore v-model="switchState" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import ChainSwitchStore from "@/model/Chain/ChainSwitchStore";
    export default {
        name: "RightTop",
        components: {ChainSwitchStore, PopForm},
        data: () => ({
            breadData: [],
            userInfo: {},

            editShow: false,
            editData: {
                old_password: "",
                new_password: "",
                new_password2: "",
            },

            switchState: false
        }),
        props: ["bread"],
        mounted: function () {
            this.setMenu();
            this.getInfo();
        },
        methods: {
            setMenu: function () {
                if(!obj.isEmpty(this.bread)){
                    this.breadData = this.bread.split("-");
                }
            },
            loginOut: function () {
                this.$store.dispatch("delToken");
                this.$root.go("account/login");
            },
            getInfo: function () {
                obj.postData("user/get_self_info", {}, res => {
                    if(res.errcode === 0) {
                        let matchStr = res.data.mobile.substring(3, 7);
                        res.data.mobile = res.data.mobile.replace(matchStr, "****");
                        this.userInfo = res.data;
                        let option = {
                            is_main: !!res.data.is_main,
                            is_unified_manage: !!res.data.is_unified_manage,
                            is_unified_user: !!res.data.is_unified_user
                        };
                        this.$store.commit("setChainOption", option);
                    }
                });
            },
            submitSave: function () {
                this.$refs["editData"].validate( valid => {
                    if(!valid) return false;

                    if(this.editData.new_password !== this.editData.new_password2){
                        obj.message.error("你两次输入的新密码不一致！");
                        return false;
                    }

                    let postData = {
                        old_pw: this.editData.old_password,
                        new_pw: this.editData.new_password,
                    };
                    obj.postData("user/update_password", postData, res => {
                        if(res.errcode === 0){
                            obj.message.success("密码修改成功");
                            this.editShow = false;
                        }else{
                            obj.message.error(res.errdesc);
                        }
                    });
                });
            },
            showSwitchStore: function () {
                this.switchState = true;
            }
        },
        watch: {
            bread: function (data) {
                this.breadData = data.split("-");
            },
            editShow: function (s) {
                if(s){
                    this.editData = {
                        old_password: "",
                        new_password: "",
                        new_password2: "",
                    };
                }
            }
        }
    }
</script>

<style scoped>
    .el-breadcrumb{
        line-height: inherit;
    }
    .right-top-box{
        display: flex;
        flex-flow: row nowrap;
        height: 25px;
        line-height: 25px;
        margin-right: 10px;
    }
    .right-top-box>.left-box{
        width: 300px;
    }
    .right-top-box>.right-box{
        flex: 1;
        min-width: 300px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
    }
    .user-avatar{
        height: 30px;
        margin-right: 10px;
    }
    .user-mobile{
        line-height: 30px;
        cursor: pointer;
    }
    .password>i{
        font-size: 17px;
        font-weight: bold;
    }
    .login-out{
        background: url("../images/icon/icon_login_out.png") no-repeat 2px center;
        background-size: 14px 14px;
        padding-left: 20px;
        width: 50px;
    }
    .user-drop-box{
        padding: 0;
        width: 150px;
    }
    .user-drop-box>li:hover{
        background-color: #f5f5f5;
        color: #000000;
    }
    .backup, .backup>button{
        width: 80px;
        height: 30px;
        display: inline-block;
    }
    .backup{
        margin-right: 20px;
    }
    .editPasswordForm{
        padding-right: 10px;
    }
    .store-name{
        padding: 0px 15px;
        height: 30px;
        line-height: 30px;
        /*background-color: #6cb1e1;*/
        border-radius: 3px;
        border: none;
        margin-right: 20px;
        color: #FFFFFF;
        cursor: pointer;
    }
</style>
